import { FC } from "react";
import { Avatar, Box, Button, Card, CardMedia, CircularProgress, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useGetUsersRolesQuery } from "../services/accounts";
import { AppState } from "../store/types";
const AUTHORIZED_ROLE_ZUID: string[] = ["31-71cfc74-4dm13", "31-71cfc74-0wn3r"];
const ROLE_ORDER_MAPPING = {
  Owner: 1,
  Admin: 2
};
type ProfileInfoProps = {
  name: string;
  role: string;
  email: string;
  imageUrl?: string;
};
const ProfileInfo: FC<ProfileInfoProps> = ({
  name,
  role,
  email,
  imageUrl = ""
}) => <Box display="flex" alignItems="center" py={1} borderBottom="1px solid" borderColor="border" data-sentry-element="Box" data-sentry-component="ProfileInfo" data-sentry-source-file="AccessDenied.tsx">
    <Avatar alt={name} src={imageUrl} data-sentry-element="Avatar" data-sentry-source-file="AccessDenied.tsx" />
    <Box ml={2} data-sentry-element="Box" data-sentry-source-file="AccessDenied.tsx">
      <Typography variant="body2" color="text.primary" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="AccessDenied.tsx">
        {name}
      </Typography>
      <Typography variant="body2" color="text.secondary" data-sentry-element="Typography" data-sentry-source-file="AccessDenied.tsx">{`${role} • ${email}`}</Typography>
    </Box>
  </Box>;
const AccessDenied = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const userRole = useSelector((state: AppState) => state.userRole);
  const {
    valid
  } = useSelector((state: AppState) => state.auth);
  const appRoute = location.pathname.split("/")[1];
  const {
    isLoading,
    data
  } = useGetUsersRolesQuery(null, {
    skip: !valid
  });
  const profileList = data?.filter((profile: any) => AUTHORIZED_ROLE_ZUID.includes(profile?.role?.systemRole?.ZUID)).map((item: any, index: number) => {
    const imagePathPart = !item?.emailHash ? "" : `/${item?.emailHash}?s=40`;
    const imagePath = `https://www.gravatar.com/avatar${imagePathPart}`;
    return {
      id: item?.ZUID,
      name: `${item?.firstName} ${item?.lastName}`,
      role: item?.role?.name,
      email: item?.email,
      imageUrl: imagePath,
      sort: item?.role?.name && ROLE_ORDER_MAPPING[item?.role?.name as keyof typeof ROLE_ORDER_MAPPING] || index + 2
    };
  }).sort((a: any, b: any) => a.sort - b.sort);
  return <Box sx={{
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "stretch",
    p: 15,
    bgcolor: "grey.50"
  }} data-sentry-element="Box" data-sentry-component="AccessDenied" data-sentry-source-file="AccessDenied.tsx">
      {isLoading ? <Box width="100%" height="100%" sx={{
      display: "grid",
      placeContent: "center"
    }}>
          <CircularProgress size={32} />
        </Box> : <Box sx={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      columnGap: 8
    }}>
          <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        width: "540px",
        rowGap: 3
      }}>
            <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "space-between",
          width: "100%",
          rowGap: 2
        }}>
              <Typography variant="h3" color="text.primary" fontWeight={700}>
                {t("shell.accessDenied")}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t("shell.accessDeniedRoleBody", {
              role: userRole?.name,
              app: `${appRoute.charAt(0).toUpperCase()}${appRoute.slice(1).toLowerCase()}`
            })}
              </Typography>
            </Box>

            <Box display="flex" flexDirection="column" justifyContent="flex-start" alignItems="stretch" width="100%" maxHeight="172px" sx={{
          overflowY: "auto"
        }}>
              {profileList.length > 0 && profileList.map((profile: any) => <ProfileInfo key={profile.id} name={profile.name} email={profile.email} role={profile.role} imageUrl={profile.imageUrl} />)}
            </Box>

            <Box sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start"
        }}>
              <Button startIcon={<ArrowBackIcon />} variant="outlined" color="primary" onClick={() => history.goBack()}>
                {t("common.goBack")}
              </Button>
            </Box>
          </Box>
          <Card elevation={0} sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "320px",
        bgcolor: "transparent"
      }}>
            <CardMedia component="img" height="100%" width="100%" image="/images/restricted.png" alt={t("shell.accessDeniedImageAlt")} />
          </Card>
        </Box>}
    </Box>;
};
export default AccessDenied;